"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var validateEmail = function validateEmail(email) {
	var valid = email.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i);
	if (valid) return true;else return false;
};
var validEmail = validateEmail;

exports.validateEmail = validateEmail;
exports.validEmail = validEmail;


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/api.js
// module id = 722
// module chunks = 0